import {ReactNode} from 'react';

import {MessagePartHandlersFromClient} from '../../core/providers/MessagePartHandlersFromClient';
import {useApp} from '../../core/hooks/appHooks';

export function AppMessagePartHandlers({children}: {children: ReactNode}) {
  const {messagePartClient} = useApp();

  return (
    <MessagePartHandlersFromClient client={messagePartClient}>
      {children}
    </MessagePartHandlersFromClient>
  );
}
